import ProgramTable from './ProgramTable';

export { ProgramTable };

export default {
	ProgramTable
};
